/* Checkout refuses a pincode we cannot deliver to (owner, 2026-10-01: "in
   not deliverable to a pincode how is the validation passing to click on
   checkout?").

   The pincode check (furniva-pincode.js) keeps its verdict with the site's one
   pincode record (localStorage 'furniva:deliver-to'): `serviceable: false`
   only when the CRM said no. While that holds, every checkout control on the
   page — the cart's and the side cart's — is disabled and says why, so
   Razorpay Magic Checkout is never opened for it.

   Only a definite "no" blocks. An unchecked pincode, a lookup that failed or
   one the CRM could not decide never does: telling someone we do not deliver
   when we might would lose an order they were ready to place. A new pincode
   (from the header, the product page or the cart) replaces the record, and
   with it the verdict. */
(function () {
  'use strict';

  var KEY = 'furniva:deliver-to';
  // The cart's checkout, the side cart's, and the product page's Buy now
  // (which opens Magic Checkout directly).
  var SELECTOR = 'button[name="checkout"].fv-checkout, button[name="checkout"].fv-cartdrawer__checkout, [data-fv-buy-now]';

  function record() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (error) { return null; }
  }

  function blockedPin() {
    var saved = record();
    return saved && saved.serviceable === false && /^\d{6}$/.test(saved.pincode) ? saved.pincode : '';
  }

  function hint(button, pin) {
    var next = button.nextElementSibling;
    var note = next && next.hasAttribute('data-fv-gate-note') ? next : null;
    // Buy now sits under the product page's own pincode answer, which says it.
    if (!pin || button.hasAttribute('data-fv-buy-now')) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement('p');
      note.setAttribute('data-fv-gate-note', '');
      note.setAttribute('role', 'alert');
      note.style.cssText = 'margin:8px 0 0;font-size:var(--fv-size-micro,12px);line-height:1.5;color:var(--fv-danger,#b42318)';
      button.insertAdjacentElement('afterend', note);
    }
    var onCart = !!button.closest('[data-fv-cart]');
    var text = 'We do not deliver to ' + pin + ' yet. ' +
      (onCart ? 'Check another pincode above to continue.' : 'Open your cart to check another pincode.');
    // Unchanged text is left alone: rewriting it would wake the observer below.
    if (note.textContent !== text) note.textContent = text;
  }

  function apply() {
    var pin = blockedPin();
    document.querySelectorAll(SELECTOR).forEach(function (button) {
      if (pin) {
        if (!button.disabled) button.setAttribute('data-fv-gated', '');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.hasAttribute('data-fv-gated')) {
        // Only what this script disabled; a stock block stays.
        button.removeAttribute('data-fv-gated');
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
      hint(button, pin);
    });
  }

  // Belt and braces: a checkout click while blocked goes nowhere, whatever
  // re-enabled the button. Capture phase, so it runs before Razorpay's own
  // document listener.
  function guard(event) {
    var target = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!target && event.type === 'submit' && event.submitter) target = event.submitter.matches(SELECTOR) ? event.submitter : null;
    if (!target || !blockedPin()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    apply();
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('submit', guard, true);

  document.addEventListener('furniva:deliver-to', apply);
  document.addEventListener('cart:refresh', apply);
  window.addEventListener('storage', function (event) { if (event.key === KEY) apply(); });
  if ('MutationObserver' in window) {
    // The cart and the side cart redraw their markup; catch new buttons.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; apply(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  apply();
})();
